import { createUseStyles } from 'react-jss'
import { phonesDown, smallDesktopDown, smallPhonesDown } from '../../../styles/const/breakpoints'
import { formLink } from '../../../styles/common/drawerForms'

const useStyles = createUseStyles(theme => ({
  activeSectionContainer: {
    overflow: 'hidden',
    marginTop: isAdvancedSectionOpen => (isAdvancedSectionOpen ? 32 : 0)
  },
  actionSection: {
    position: 'relative',
    transform: isAdvancedSectionOpen => (isAdvancedSectionOpen ? 'translateY(0px)' : 'translateY(-200px)'),
    transition: 'width .2s ease-out, transform .2s ease-out'
  },
  section: {
    margin: 0,
    padding: '18px 20px 36px'
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 700,
    marginBottom: 32,
    paddingRight: 40
  },
  sectionSubTitle: {
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 8
  },
  closeBtn: {
    position: 'absolute',
    right: 16,
    top: 16,
    width: 16,
    height: 16,
    '& svg': {
      width: 16,
      height: 16
    }
  },
  link: {
    extend: formLink
  },
  subSectionsContainer: {
    display: 'flex',
    gap: 24,
    justifyContent: 'space-between',
    padding: '0 20px'
  },
  setUpPartnerSubSectionsContainer: {
    padding: '0 6px',
    columnGap: 16
  },
  campaignsSubSectionContainer: {
    columnGap: 60
  },
  reportsSubSectionContainer: {
    columnGap: 86
  },
  subSection: {
    flex: 1
  },
  numberSubSection: {
    display: 'flex',
    columnGap: 9,
    '& $sectionSubTitle': {
      marginTop: 1,
      marginBottom: 12
    }
  },
  number: {
    minWidth: 22,
    maxWidth: 22,
    minHeight: 22,
    maxHeight: 22,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    background: theme.brandPrimary,
    border: `1px solid ${theme.brandPrimary}`,
    borderRadius: '50%'
  },
  actionButton: {
    marginTop: 8
  },
  multiPlatformCampaignSubSection: {},
  [`@media screen and (${smallDesktopDown})`]: {
    campaignsSubSectionContainer: {
      columnGap: 32
    },
    reportsSubSectionContainer: {
      columnGap: 32
    }
  },
  [`@media screen and (${phonesDown})`]: {
    subSectionsContainer: {
      flexWrap: 'wrap',
      columnGap: 16
    },
    campaignsSubSectionContainer: {
      columnGap: 16
    },
    reportsSubSectionContainer: {
      columnGap: 16
    },
    subSection: {
      flex: 'none',
      width: '100%',
      maxWidth: 'calc(50% - 8px)'
    },
    multiPlatformCampaignSubSection: {
      maxWidth: '100%'
    }
  },
  [`@media screen and (${smallPhonesDown})`]: {
    subSection: {
      maxWidth: '100%'
    }
  }
}))

export default useStyles
